export const supportedFileTypes = ['PDF', 'JPEG', 'PNG'] as const

export const acceptedMimeTypes = ['application/pdf', 'image/jpeg', 'image/png'] as const

type AcceptedMimeType = (typeof acceptedMimeTypes)[number]

const signatures: { mime: AcceptedMimeType; bytes: number[] }[] = [
  { mime: 'application/pdf', bytes: [0x25, 0x50, 0x44, 0x46] },
  { mime: 'image/jpeg', bytes: [0xff, 0xd8, 0xff] },
  { mime: 'image/png', bytes: [0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a] },
]

export const detectFileType = (file: File): Promise<AcceptedMimeType | null> => {
  return new Promise((resolve) => {
    const reader = new FileReader()

    reader.onloadend = () => {
      if (!reader.result) {
        resolve(null)
        return
      }

      const header = new Uint8Array(reader.result as ArrayBuffer)

      for (const sig of signatures) {
        if (sig.bytes.every((byte, i) => header[i] === byte)) {
          resolve(sig.mime)
          return
        }
      }

      resolve(null)
    }

    reader.onerror = () => resolve(null)

    const blob = file.slice(0, 8)
    reader.readAsArrayBuffer(blob)
  })
}
